/* src/app/dialogs/role-editor/role-editor.component.css */
/*# sourceMappingURL=role-editor.component-IXYAAWFJ.css.map */
